import axios from 'axios';

export function getPendingPersonalContent(token) {
    return axios.get(
        `${process.env.REACT_APP_API_URL}/admin/pending-personal-content`,
        {
            headers: {
                Authorization: `${token}`,
            },
        },
    );
}

export function approvePersonalContent(screenId, slotId, payload, token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/screens/${screenId}/slots/${slotId}/approve-personal-content`,
        payload || {},
        {
            headers: {
                Authorization: `${token}`,
            },
        },
    );
}

export function rejectPersonalContent(screenId, slotId, payload, token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/screens/${screenId}/slots/${slotId}/reject-personal-content`,
        payload || {},
        {
            headers: {
                Authorization: `${token}`,
            },
        },
    );
}
